import {
  GetAgentDocumentUnsignedParams,
  GetAgentDocumentUnsignedResponse,
} from '@customTypes/api/Agent';
import { GetResponse } from '@customTypes/api/Commons';
import { Endpoints, KrakendServiceAPI } from '@service/index';
import queryKeys from '@src/queries/keys';

import { useQuery } from '../helper/useQuery';

interface UseGetAgentDocumentUnsigned {
  limit_by_one?: boolean;
  enabled?: boolean;
}

const useGetAgentDocumentUnsigned = ({
  limit_by_one,
  enabled = true,
}: UseGetAgentDocumentUnsigned) => {
  return useQuery<number>(
    [queryKeys.agentDocumentUnsigned, limit_by_one],
    () =>
      KrakendServiceAPI.get<
        GetAgentDocumentUnsignedParams,
        GetResponse<GetAgentDocumentUnsignedResponse>
      >(Endpoints.AgentDocumentUnsigned(), {
        ...(limit_by_one && { limit_by_one }),
      }).then(response => response.data.data.agent_document_unsigned),
    { cacheTime: 500, enabled },
  );
};

export default useGetAgentDocumentUnsigned;
